import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M26,25v1a2.0059,2.0059,0,0,1-2,2H4a2.0059,2.0059,0,0,1-2-2V20.71a12.3828,12.3828,0,0,0,2,2.24c.35.29.68.55,1,.77a11.0609,11.0609,0,0,0,1.89,1.07A3.04,3.04,0,0,0,8,25Z"/><path d="M29.61,21.2A10.5076,10.5076,0,0,1,26,13V6a2.0059,2.0059,0,0,0-2-2H4A2.0059,2.0059,0,0,0,2,6v8a9.5405,9.5405,0,0,0,2,6.06,9.7287,9.7287,0,0,0,1,1.09,9.3775,9.3775,0,0,0,2.63,1.78A.9692.9692,0,0,0,8,23H29a1.0033,1.0033,0,0,0,.61-1.8ZM6,13a1.0029,1.0029,0,0,1,1-1H20a1,1,0,0,1,0,2H7A1.0029,1.0029,0,0,1,6,13ZM16,9a1.0029,1.0029,0,0,1-1,1H7A1,1,0,0,1,7,8h8A1.0029,1.0029,0,0,1,16,9Z"/>';
export var NoteSVG = function NoteSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
NoteSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(NoteSVG);